"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBasicHeaders = exports.getAuthHeaders = exports.JSON_SEND = exports.JSON_GET = exports.JSON_BOTH = exports.ANALYTICS_HEADERS = void 0;
var _btoaLite = _interopRequireDefault(require("btoa-lite"));
var _config = _interopRequireDefault(require("../../consts/config"));
var _client = require("../platform/client");
var _cookies = require("@kiwicom/cookies");
var session = _interopRequireWildcard(require("../session/session"));
var _session2 = require("../../consts/session");
var _getBrandId = require("../utils/getBrandId");
var _isWebview$toString, _isWebview, _load, _load2, _load3, _load4, _load5, _session$load, _load6, _document, _window, _window$location;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const JSON_GET = exports.JSON_GET = {
  Accept: "application/json"
};
const JSON_SEND = exports.JSON_SEND = {
  "Content-Type": "application/json"
};
const JSON_BOTH = exports.JSON_BOTH = {
  ...JSON_GET,
  ...JSON_SEND
};
const ANALYTICS_HEADERS = exports.ANALYTICS_HEADERS = {
  "X-Analytics-Is-Webview": (_isWebview$toString = (_isWebview = (0, _client.isWebview)()) === null || _isWebview === void 0 ? void 0 : _isWebview.toString()) !== null && _isWebview$toString !== void 0 ? _isWebview$toString : "",
  "X-Analytics-Currency": (_load = (0, _cookies.load)(_cookies.Cookie.CURRENCY)) !== null && _load !== void 0 ? _load : "",
  "X-Analytics-Language": (_load2 = (0, _cookies.load)(_cookies.Cookie.KW_LANGUAGE)) !== null && _load2 !== void 0 ? _load2 : "",
  "X-Analytics-Locale": (_load3 = (0, _cookies.load)(_cookies.Cookie.LANGUAGE)) !== null && _load3 !== void 0 ? _load3 : "",
  "X-Analytics-Market": (_load4 = (0, _cookies.load)(_cookies.Cookie.KW_MARKET)) !== null && _load4 !== void 0 ? _load4 : "",
  "X-Analytics-Visitor-Session-Id": (_load5 = (0, _cookies.load)(_cookies.Cookie.KW_SESSION_ID)) !== null && _load5 !== void 0 ? _load5 : "",
  "X-Analytics-Session-Id": (_session$load = session.load(_session2.SESSION_ID)) !== null && _session$load !== void 0 ? _session$load : "",
  "X-WHOIAM": (_load6 = (0, _cookies.load)(_cookies.Cookie.USER_ID)) !== null && _load6 !== void 0 ? _load6 : "",
  "X-Analytics-Referer": typeof document !== "undefined" ? ((_document = document) === null || _document === void 0 ? void 0 : _document.referrer) || "" : "",
  "X-Analytics-Url": typeof window !== "undefined" ? ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href) || "" : "",
  "X-Analytics-Branding-Id": (0, _getBrandId.getBrandId)()
};

// Create Authorization header with user's app id
// which in production require additional header: CAPTCHA-TOKEN
const makeAuthHeaderWithAppId = appId => `Basic ${(0, _btoaLite.default)(`${appId}:${_config.default.appSecret}`)}`;
const getBasicHeaders = (turnstileToken, disabledTurnstileAppId) => ({
  ...JSON_BOTH,
  Authorization: makeAuthHeaderWithAppId(disabledTurnstileAppId !== null && disabledTurnstileAppId !== void 0 ? disabledTurnstileAppId : _config.default.appName),
  "CAPTCHA-TOKEN": turnstileToken !== null && turnstileToken !== void 0 ? turnstileToken : ""
});
exports.getBasicHeaders = getBasicHeaders;
const getAuthHeaders = accessToken => ({
  ...JSON_BOTH,
  Authorization: `Bearer ${accessToken}`
});
exports.getAuthHeaders = getAuthHeaders;